import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { Button, ButtonType } from '../../UIkit/components/controls/Button/Button.tsx'
import { Refresh } from '../../UIkit/components/icons/Refresh.tsx'

export enum PollingState {
    on = 'on',
    off = 'off'
}
export const DEFAULT_POLLING_KEY = 'polling'
export const PollingButton = ({ keyName = DEFAULT_POLLING_KEY }: { keyName?: string }) => {
    const [params, setParams] = useSearchParams()
    const toggle = useCallback(() => {
        const value = params.get(keyName) === PollingState.on
        const newParams = new URLSearchParams(params)
        newParams.set(keyName, value ? PollingState.off : PollingState.on)
        setParams(newParams)
    }, [params])
    const active = params.get(keyName) === PollingState.on
    const { t } = useTranslation()
    return (
        <Button
            title={t(active ? 'turn off real time updates' : 'turn on real time updates')}
            minWidth={50}
            icon={<Refresh />}
            onClick={toggle}
            type={active ? ButtonType.primary : ButtonType.secondary}
        />
    )
}
